'use client'

import type { PointOfInterestImage } from 'landings/Home/Home.type'
import { pointOfInterestImageLoaderFactory } from 'landings/utils/pointOfInterestImageLoaderFactory'
import { getPointOfInterest } from '../../../utils/getPointOfInterest/getPointOfInterest'
import { BannerImage } from '../../Shared/BannerImage/BannerImage'

interface HeroBannerPromoImageProps {
	readonly image: PointOfInterestImage
	readonly priority?: boolean
}

const ASPECT_RATIO_PORTRAIT_WIDTH = 5
const ASPECT_RATIO_PORTRAIT_HEIGHT = 7
const ASPECT_RATIO_PORTRAIT =
	ASPECT_RATIO_PORTRAIT_WIDTH / ASPECT_RATIO_PORTRAIT_HEIGHT

export function HeroBannerPromoImage({
	image,
	priority = false,
}: HeroBannerPromoImageProps) {
	const heroBannerImageLoader = pointOfInterestImageLoaderFactory(
		getPointOfInterest({ image }),
		(width) => width / ASPECT_RATIO_PORTRAIT
	)

	return (
		<BannerImage
			image={image}
			sizes='(min-width: 1024px) calc(75vh * 5 / 7), 100vw'
			imageLoader={heroBannerImageLoader}
			priority={priority}
		/>
	)
}
